import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/write-off-inventory/global'

export const WRITE_OFF_INVENTORY_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
